// Styles
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'
import 'vue-toast/dist/vue-toast.min.css'
import '@fortawesome/fontawesome'
import '@fortawesome/fontawesome-free-brands'
import './assets/styles/animate.css'
import './assets/styles/bootstrap-formhelpers.min.css'
import './assets/styles/simple-line-icons.css'
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'
// import '@fortawesome/fontawesome-free-solid/faSpinner'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate'
import Toasted from 'vue-toasted'
import VCharts from 'v-charts'
import VDateRange from 'vuetify-daterange-picker'
import VShowSlide from 'v-show-slide'
import ReadMore from 'vue-read-more'
import VueCookies from 'vue-cookies'
import VTooltip from 'v-tooltip'
import ECharts from 'vue-echarts'

import VueLocalStorage from 'vue-localstorage'
import Router from 'vue-router'

import './components/_globals'
import {
  createRouter
} from './router/index'
import store from './store'
import services from './services'
import settings from './settings'
// import VueAnalytics from 'vue-analytics'

const moment = require('moment')
Vue.use(require('vue-moment'), {
  moment
})

// export const this.$eventEmitter = new Vue()
Vue.prototype.$eventEmitter = new Vue()

Vue.use(Toasted, {
  type: 'success',
  position: 'top-right',
  duration: 7000,
  action: {
    text: 'Close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    }
  }
})

Vue.use(Vuetify, {})
Vue.use(VueCookies)
Vue.use(VeeValidate)
Vue.use(services)
Vue.use(VCharts)
Vue.use(VShowSlide)
Vue.use(VDateRange)
Vue.use(VTooltip)
Vue.use(Toasted, {
  duration: 4000,
  type: 'info'
})
Vue.use(VueLocalStorage)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
Vue.use(ReadMore)

Vue.component('v-chart', ECharts)

VueCookies.config('365d')

store.commit('SET_SETTINGS', settings)

Vue.config.productionTip = false

let router = createRouter()

// Vue.use(VueAnalytics, {
//   id: 'UA-72578924-3',
//   router
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js